module.exports = __webpack_public_path__ + "static/img/無創產前親子鑑定-01.ae27940.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/non-invasive-prenatal-paternity-test/無創產前親子鑑定-01.jpg
// module id = YUvL
// module chunks = 0